import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import LanguageSelector from './LanguageSelector'
import Errors from './Errors'
import defaultValue from '../Lib/defaultValue'

const Text = ({
  storedData, showErrors, onChange, name, translatable, options: { label }, validations, languages = [],
}) => {
  let user = null
  if (Cookies.get('user')) {
    user = JSON.parse(Cookies.get('user'))
  }
  const allowedCountries = user && typeof user.allowedCountries !== 'undefined' ? user.allowedCountries : Object.keys(languages)

  const [language, setLanguage] = useState(translatable ? allowedCountries[0] : null)
  const [value, setValue] = useState(defaultValue(name, storedData, translatable))
  const [errors, setErrors] = useState([])
  const [currentValue, setCurrentValue] = useState('')
  const [textDir, setTextDir] = useState('auto')

  const onChangeText = e => {
    if (translatable) {
      value[language] = `${e.target.value}`
      setValue({ ...value })
    } else {
      setValue(`${e.target.value}`)
    }
    setCurrentValue(e.target.value)
  }

  useEffect(() => {
    setCurrentValue(translatable ? `${value[language]?.trim() || ''}` : `${value?.trim()}`)
    setTextDir((language === 'mea_MEA') ? 'rtl' : 'auto')
  }, [language, translatable])

  useEffect(() => {
    if (defaultValue(name, storedData, translatable) === value) return
    const errs = Errors(value, validations, translatable, languages)
    onChange(name, value, errs)
    setErrors(errs)
  }, [value])

  const input = <input
    name={name}
    className={`w-full rounded ${translatable && allowedCountries[0] === language ? 'rounded-tl-none' : ''} px-2 py-1 ${showErrors && errors.length > 0 ? 'border border-error' : ''} bg-white outline-none placeholder-gray`}
    type="text"
    placeholder={label}
    value={currentValue}
    onChange={onChangeText}
    dir={textDir}
  />

  return (
    <div>
      <label>{label}</label>
      {translatable
        ? <LanguageSelector
          value={value}
          updateValue={v => {
            setValue(v)
            setCurrentValue(v[language])
          }}
          language={language}
          languages={languages}
          onChangeLanguage={v => setLanguage(v)}>
          {input}
        </LanguageSelector>
        : input}
    </div>
  )
}

export default Text
